import { findUser } from "@/api/common";
import { ComTools } from "@/utils/tools"
export default {
  namespaced: true,
  state: {
    userInfo: null
  },
  mutations: {
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    getUserInfos({ commit }) {
      return new Promise((resolve, reject) => {
        findUser({}).then(res => {
          if (res.code === 0) {
            commit("updateUserInfo", res.data);
            if (!ComTools.isEmptyString(res.data)) {
              ComTools.setToken(res.data.token);
            }
            resolve(res.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js